import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'templates',
    component: () => import('@/views/TemplateListingView.vue'),
  },
  {
    path: '/templates/:id',
    name: 'template-detail',
    component: () => import('@/views/TemplateDetailView.vue'),
  },
  {
    path: '/wizard',
    name: 'wizard',
    component: () => import('@/views/TemplateWizardView.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
]

const router = createRouter({
  history: createWebHistory('/'),
  routes,
})

export default router
